import { z } from 'zod';

/**
 * 코드 형식 정규식.
 *
 * 서버 명세(Swagger): 4~12자리 영문 대문자 + 숫자.
 * 운영 정책상 클라이언트는 4자리 입력으로 고정한다.
 */
const CODE_PATTERN = /^[A-Z0-9]{4}$/;

/** 코드 길이(자릿수). 서버 정책 변동 시 이 상수만 수정하면 된다. */
export const CODE_LENGTH = 4;

/**
 * 코드 입력 폼 스키마.
 *
 * - 입력은 자동으로 trim/uppercase/공백·하이픈 제거 정규화된다.
 * - 길이/형식이 맞지 않으면 한국어 에러 메시지가 매핑된다.
 */
export const codeSchema = z.object({
  code: z
    .string()
    .trim()
    .min(1, '코드를 입력해 주세요.')
    .transform((v) => v.toUpperCase().replace(/[\s\-_]/g, ''))
    .pipe(
      z
        .string()
        .regex(
          CODE_PATTERN,
          `코드는 영문 대문자/숫자 ${String(CODE_LENGTH)}자리예요. (예: AB12)`,
        ),
    ),
});

/** 폼 입력 타입 — `code` 1개의 string 필드. */
export type CodeFormValues = z.infer<typeof codeSchema>;

/** UI에서 placeholder 등으로 노출하는 코드 예시. */
export const CODE_EXAMPLE = 'AB12';
